import { Component, OnDestroy, OnInit, Signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { stages } from '../../removal-of-trees-or-shrubs.routes';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { TreesCuttingInfoForm } from './forms/trees-cutting-info-form';
import { ReactiveFormsModule } from '@angular/forms';
import { ApplicationAppEntityApplicationRead, TreeToRemoveAppEntityTreeToRemoveWrite } from '../../../../../../openapi';
import { PropertyOwnerFormComponent } from './components/property-owner-form/property-owner-form.component';
import {
  TreeToRemoveItemFormComponent
} from './components/tree-to-remove-item-form/tree-to-remove-item-form.component';
import { TreeToRemoveItemForm } from './forms/tree-to-remove-item.form';
import { CommonModule } from '@angular/common';
import { TreesToRemovePreviewComponent } from './components/trees-to-remove-preview/trees-to-remove-preview.component';
import { loadTreeRemovalReasons, updateTreeCuttingInfo } from '../../../../../../store/actions/application.actions';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { DatePickerComponent } from '../../../../../../common/date-picker/date-picker.component';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { ObjectTypeEnum } from "../../../../../../services/tree-to-remove.common.service";

@Component({
  selector: 'app-trees-cutting-info-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    PropertyOwnerFormComponent,
    TreeToRemoveItemFormComponent,
    CommonModule,
    TreesToRemovePreviewComponent,
    DatePickerComponent,
    ValidationErrorsComponent
  ],
  providers: [TreesCuttingInfoForm, TreeToRemoveItemForm],
  templateUrl: './trees-cutting-info-section.component.html'
})
export class TreesCuttingInfoSectionComponent implements OnInit, OnDestroy {

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public stages: string[] = stages;

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public treeItemFormType: ObjectTypeEnum | null = null;
  public currentTreeItemIndex: number | undefined;

  private fetchApplication: Subscription = toObservable(this.application).subscribe((app) => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store$: Store,
    public form: TreesCuttingInfoForm,
    public treeToRemoveItemForm: TreeToRemoveItemForm
  ) {
  }

  public onAddTreeItemForm(type: ObjectTypeEnum): void {
    if (type  === 'tree') {
      this.treeToRemoveItemForm?.createTrunkCircumference130Form();
    } else {
      this.treeToRemoveItemForm?.createTrunkCircumference130Control();
    }
    this.treeItemFormType = type;
  }

  public onEditTreeItemForm(i: number, v: TreeToRemoveAppEntityTreeToRemoveWrite): void {
    this.currentTreeItemIndex = i;
    this.treeItemFormType = v.objectType || null;
    if (v.objectType  === 'tree') {
      this.treeToRemoveItemForm?.createTrunkCircumference130Form();
    } else {
      this.treeToRemoveItemForm?.createTrunkCircumference130Control();
    }
    this.treeToRemoveItemForm.patchFormValues(v);
  }

  public onCancelTreeItemForm(): void {
    this.treeItemFormType = null;
    this.currentTreeItemIndex = undefined;
  }

  public onSubmitTreeItemForm(value: TreeToRemoveAppEntityTreeToRemoveWrite): void {
    if (this.currentTreeItemIndex !== undefined) {
      this.form.editTreeToRemove(value, this.currentTreeItemIndex);
    } else {
      this.form.addTreeToRemove(value);
    }
    this.treeItemFormType = null;
    this.currentTreeItemIndex = undefined;
  }

  public submitAndGoNext(): void {
    if (this.form.valid && this.form.treesToRemoveValues.length) {
      this.store$.dispatch(
        updateTreeCuttingInfo({
          applicationId: this.application()?.uuid || '',
          treesToRemove: this.form.treesToRemoveValues,
          application: this.form.toWriteModel(),
          successFnc: (applicationId: string) => {
            this.router.navigate(
              ['../oswiadczenia'],
              {
                relativeTo: this.route
              }
            );
          },
          failureFnc: () => {
          }
        })
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], {relativeTo: this.route});
  }

  public ngOnInit(): void {
    this.store$.dispatch(loadTreeRemovalReasons());
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
